import React, { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { getTheme } from "@/lib/theme";
import { api } from "@/api/client";

export function Footer() {
  const { selectedBusinessId } = useAuth();
  const theme = getTheme(selectedBusinessId);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!selectedBusinessId) return;
    api.getPaymentInfo(selectedBusinessId).then(setInfo).catch(() => {});
  }, [selectedBusinessId]);

  return (
    <footer className="mt-24 border-t" style={{ borderColor: "var(--border)", background: "var(--surface-2)" }}>
      <div className="container-app py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-display text-2xl" style={{ color: "var(--ink)" }}>
            {theme.name}
          </div>
          <p className="mt-2 text-sm max-w-xs" style={{ color: "var(--muted)" }}>
            {info?.tagline || theme.tagline}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-semibold mb-3" style={{ color: "var(--muted)" }}>
            Payment handles
          </div>
          <ul className="space-y-1.5 text-sm" style={{ color: "var(--ink)" }}>
            {info?.zelle_handle && <li>Zelle · {info.zelle_handle}</li>}
            {info?.cashapp_handle && <li>CashApp · {info.cashapp_handle}</li>}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-semibold mb-3" style={{ color: "var(--muted)" }}>
            Follow
          </div>
          {info?.instagram_handle && (
            <a
              href={`https://instagram.com/${info.instagram_handle}`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold"
              style={{ color: "var(--brand)" }}
            >
              <Instagram size={16} /> @{info.instagram_handle}
            </a>
          )}
        </div>
      </div>
      <div className="border-t py-4 text-center text-xs" style={{ borderColor: "var(--border)", color: "var(--muted)" }}>
        © {new Date().getFullYear()} {theme.name}. Baked & catered with care.
      </div>
    </footer>
  );
}
